import { gql } from 'graphql-request';

// The grid-backed species figures for one site, read by the site summary's
// species section.
export const siteSpeciesCountsQuery = gql`
    query getSiteSpeciesCounts($siteId: String!) {
        siteSummary {
            getSiteSpeciesCounts(siteId: $siteId) {
                snapshot
                redListSpeciesCount
                threatenedSpeciesCount
                invasiveSpeciesCount
                speciesCount
                iucn {
                    category
                    count
                }
            }
        }
    }
`;

export type SiteSpeciesIucnCount = {
    category: string;
    count: number;
};

export type SiteSpeciesCounts = {
    /** The grid snapshot these figures were read from. */
    snapshot: string;
    /** CR + EN + VU + NT, non-invasive. */
    redListSpeciesCount: number;
    /** CR + EN + VU, non-invasive: the threatened subset of redListSpeciesCount. */
    threatenedSpeciesCount: number;
    invasiveSpeciesCount: number;
    /** Every distinct species predicted, invasives and unassessed included. */
    speciesCount: number;
    iucn: SiteSpeciesIucnCount[];
};

export type SiteSpeciesCountsQueryResult = {
    siteSummary: {
        getSiteSpeciesCounts: SiteSpeciesCounts;
    };
};
